import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SampleComponent } from './sample.component';
import { SidebarModule } from 'src/app/sidebar/sidebar.module';
import { NavbarModule } from 'src/app/shared/navbar/navbar.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [SampleComponent],
  imports: [
    CommonModule,
    SidebarModule,
    NavbarModule,
    RouterModule
  ],
  entryComponents: [SampleComponent],
  
})
export class SampleModule { }
